/* eslint-disable no-unused-vars */

import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import moment from 'moment/moment'

const styles = theme => ({
  wrapper: {
    [theme.breakpoints.down(760)]: {
      textAlign: 'center',
      marginBottom: 10,
    },
  },
  pageSizeSelect: {
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: 14,
    color: `var(--gameday-paging-rowsSelectColor, ${theme.paging.rowsSelectColor})`,
  },
  pageSizeIcon: {
    width: 16,
    height: 16,
    top: 'calc(50% - 8px)',
  },
  rowsInfo: {
    fontSize: 11,
    color: `var(--gameday-paging-rowsColor, ${theme.paging.rowsColor})`,
    marginTop: -4,
  },
})

const PagingSetting = ({
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  headers,
  total,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  exportDataUrl,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  exportDataPath,
  totalSelected,
  itemPerPage,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  itemName,
  onChangePageSize,
  options,
  currentPage,
  classes,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  showExportData,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  exportFileName,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  smallPagination,
  hideSizePerPage,
  hideShowingRows,
}) => {
  let rangeFrom = (currentPage - 1) * itemPerPage + 1
  let rangeTo = currentPage * itemPerPage
  if (rangeTo > total) {
    rangeTo = total
  }
  if (total === 0) {
    rangeFrom = 0
    rangeTo = 0
    return null
  }

  return (
    <div className={classes.wrapper}>
      {!hideSizePerPage && (
        <Select
          classes={{
            select: classes.pageSizeSelect,
            icon: classes.pageSizeIcon,
          }}
          onChange={e => onChangePageSize(e.target.value)}
          value={itemPerPage}
          disableUnderline
        >
          {options.map((option, i) => (
            // eslint-disable-next-line react/no-array-index-key
            // biome-ignore lint/suspicious/noArrayIndexKey: TODO
            <MenuItem key={i} value={option}>
              {itemPerPage === option && 'Show'} {option}
            </MenuItem>
          ))}
        </Select>
      )}
      <div className={cn(classes.rowsInfo)}>
        {!hideShowingRows && (
          <span>
            Showing rows {rangeFrom}-{rangeTo} of {total}
          </span>
        )}
        {totalSelected > 0 && <span>({totalSelected} selected)</span>}
      </div>
    </div>
  )
}

PagingSetting.defaultProps = {
  headers: [],
  total: 0,
  totalSelected: 0,
  itemName: 'items',
  itemPerPage: 25,
  onChangePageSize: () => {},
  options: [5, 10, 25, 50],
  currentPage: 1,
  exportFileName: moment().format('DD_MM_YYYY hh:mm'),
  smallPagination: false,
  hideSizePerPage: false,
  hideShowingRows: false,
}

export default withStyles(styles)(PagingSetting)
